import { cloneDeep } from 'lodash';
import {
  SubmissionPayload,
  SubmissionPayloadSection,
  SubmissionActionType,
  SubmissionState,
  SET_CONTEXT_QUESTION_ANSWER,
  SET_MAIN_QUESTION_ANSWER,
  RESET_SUBMISSION_STATE,
  SET_DISCARD_SUBMISSION_SECTION,
  RECALL_SUBMISSION_STATE,
  DELETE_SECTION_SUBMISSIONS,
  CREATE_EMPTY_SUBMISSION_SECTIONS,
} from '../types/submissionTypes';

/** todo: introduce SubmissionState as initial state  */
function createInitialState(): SubmissionState {
  return {
    payload: {
      sections: [],
      openQuestionAnswers: {},
      // customFieldsAnswers: {},
      // customFieldsFreeTextAnswers: {},
      generalComment: '',
    } as SubmissionPayload,
  };
}

function createSection(): SubmissionPayloadSection {
  /* change-log of versions for submission payload
    1. initial state, all properties expect of the following
    2. introduced context variable for open questions per section
    3. introduced discardSubmission
  */
  return {
    version: 3,
    questions: {},
    context: {},
    discardSubmission: false,
  };
}

export default (state = createInitialState(), action: SubmissionActionType): SubmissionState => {
  switch (action.type) {
    case SET_CONTEXT_QUESTION_ANSWER: {
      const sections = cloneDeep(state.payload.sections);
      const { sectionIndex, questionUuid, payload } = action;
      if (!sections[sectionIndex]) {
        sections[sectionIndex] = createSection();
      }
      sections[sectionIndex].context[questionUuid] = payload;
      return {
        ...state,
        payload: { ...state.payload, sections },
      };
    }
    case SET_DISCARD_SUBMISSION_SECTION: {
      const sections = cloneDeep(state.payload.sections);
      const { sectionId: sectionIdToDiscard, discard } = action.payload;
      if (!sections[sectionIdToDiscard]) {
        sections[sectionIdToDiscard] = createSection();
      }
      // to make sure that the current value set manually is not overwritten.
      // once we introduce submission flag per section
      sections[sectionIdToDiscard].discardSubmission = discard;
      return {
        ...state,
        payload: { ...state.payload, sections },
      };
    }
    case SET_MAIN_QUESTION_ANSWER: {
      const sections = cloneDeep(state.payload.sections);
      if (!sections[action.sectionIndex]) {
        sections[action.sectionIndex] = createSection();
      }
      if (!sections[action.sectionIndex].questions[action.questionUuid]) {
        sections[action.sectionIndex].questions[action.questionUuid] = {
          answers: [],
        };
      }

      sections[action.sectionIndex]
        .questions[action.questionUuid]
        .answers[action.sampleIndex] = action.answerPayload;

      const newState = {
        ...state,
        payload: { ...state.payload, sections },
      };
      return newState;
    }

    case RECALL_SUBMISSION_STATE:
      return {
        ...state,
        payload: action.payload,
      };

    case RESET_SUBMISSION_STATE: {
      return createInitialState();
    }

    case DELETE_SECTION_SUBMISSIONS: {
      const newState = {
        ...state,
        payload: {
          ...state.payload,
          sections: state.payload.sections.map((s, i) => {
            if (i === action.payload.sectionId) {
              return {
                ...s,
                questions: {},
                context: {},
              };
            }
            return s;
          }),
        },
      };
      return newState;
    }

    case CREATE_EMPTY_SUBMISSION_SECTIONS: {
      return {
        ...state,
        payload: {
          ...state.payload,
          sections: [...new Array(action.payload.numSections).keys()].map(() => createSection()),
        },
      };
    }

    default:
      return state;
  }
};
